"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Colors = require("../00_environment/Colors");

var _Fonts = require("../00_environment/Fonts");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LegendItem = function LegendItem(_ref) {
  var color = _ref.color,
      borderColor = _ref.borderColor,
      bgColor = _ref.bgColor,
      label = _ref.label,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 30 : _ref$width,
      _ref$marginRight = _ref.marginRight,
      marginRight = _ref$marginRight === void 0 ? 10 : _ref$marginRight;
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "SeatMatrixAvailabilityLegend",
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: width,
      height: Math.round(4 * width / 5),
      lineHeight: Math.round(4 * width / 5),
      borderRadius: 5,
      border: "solid 1.5px ".concat(borderColor),
      backgroundColor: bgColor,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: color,
      fontWeight: 'bold',
      marginLeft: 10
    }
  }, "x"), /*#__PURE__*/_react["default"].createElement("div", {
    style: (0, _Fonts.withBoldFont)({
      marginLeft: 10,
      marginRight: marginRight,
      fontWeight: 600,
      fontSize: '0.95rem',
      flexWrap: 'wrap'
    })
  }, label));
};

var SeatMatrixLegend = function SeatMatrixLegend(_ref2) {
  var t = _ref2.translator;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '80%',
      margin: 'auto',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: 30,
      marginBottom: 10
    }
  }, /*#__PURE__*/_react["default"].createElement(LegendItem, {
    color: _Colors.primaryColor,
    borderColor: _Colors.primaryColor,
    bgColor: _Colors.highlightedWidgetBackgroundColor,
    label: t('Selected seat')
  }), /*#__PURE__*/_react["default"].createElement(LegendItem, {
    color: "gray",
    borderColor: _Colors.widgetBorderColor,
    bgColor: "white",
    label: t('Free seat')
  }), /*#__PURE__*/_react["default"].createElement(LegendItem, {
    color: "white",
    borderColor: _Colors.seatMatrixBusyColor,
    bgColor: _Colors.seatMatrixBusyColor,
    label: t('Busy seat'),
    marginRight: 0
  }));
};

var _default = SeatMatrixLegend;
exports["default"] = _default;